/*Production*/
const appEnv = {
  "HOST_SERVICE_NODE": "http://api.signmeincenter.com/api",
  "TIME_OUT": 60000,
  "BEAR_TOKEN_NODE": "Fiistars2020 "
};
//Dev
// const appEnv = {
//   "HOST_SERVICE_NODE": "http://localhost:8181/api",
//   "TIME_OUT": 60000,
//   "BEAR_TOKEN_NODE": "Fiistars2020 "
// };
export default appEnv;
